import { forwardRef, type JSX } from "react";

import dynamic from "next/dynamic";
import { FieldValues } from "react-hook-form";

import { CheckboxProps, CheckboxSsrProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardCheckbox = dynamic(
  () => import("./DashboardCheckboxSsr").then((mod) => mod.DashboardCheckboxSsr),
  { ssr: false }
) as <T extends FieldValues>(props: CheckboxSsrProps<T>) => JSX.Element;

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
const DashboardCheckboxInner = forwardRef(function DashboardCheckboxInner<T extends FieldValues>(
  props: CheckboxProps<T>,
  ref: React.Ref<HTMLButtonElement>
) {
  return <DynamicDashboardCheckbox {...props} forwardedRef={ref} />;
});

export const DashboardCheckbox = DashboardCheckboxInner as (<T extends FieldValues>(
  props: CheckboxProps<T> & React.RefAttributes<HTMLButtonElement>
) => JSX.Element) & {
  displayName: string;
};

DashboardCheckbox.displayName = "DashboardCheckbox";
